import React from 'react'
import { useState } from 'react'
import portrait1 from "../assets/services_injectables.jpg"
import portrait2 from "../assets/services_laser.jpg"
import portrait3 from "../assets/services_aesthetics2.jpg"
import Lightbox from "../lightbox/Lightbox.jsx" 

const Info = (props) => {

  const openLightbox = props.openLightbox

  const openLightbox1 = () =>
  {
    openLightbox("Injectables", 1)
  }

  const openLightbox2 = () =>
  {
    
    openLightbox("Laser & Energy Devices", 2)
  }

  const openLightbox3 = () =>
  {
    openLightbox("Aesthetic Treatments", 3)
  }

  return (
    <>
      <div className='services__info grid' >

        <div className="services__box" onClick={openLightbox1}>
          <h2 className="services__title">Injectables</h2>
          <img className="services__portrait" src={portrait1} alt="beautiful young woman with darker skin" />
          <div className='services__list leftList'>
            <ul>
              <li>Neuromodulators <br /> &#40;Botox&#174;, Nuceiva&#174;&#41;</li>
              <li>Dermal Fillers</li>
            </ul>
          </div>
        </div>

        <div className="services__box" onClick={openLightbox2}>
          <h3 className="services__title">Laser & Energy Devices</h3>
          <img className="services__portrait" src={portrait2} alt="beautiful older woman with lighter skin" />
          <div className="services__list middleList">
            <ul>
              <li>Intense Pulsed Light</li>
              <li>PicoSure Pro&#174;</li>
              <li>Potenza® RF Microneedling</li>     
              <li>Icon&#174; Laser</li>     
              <li>TempSure&#174; RF</li>
              <li>FlexSure&#174; RF</li>
              <li>SculpSure&#174;</li>

            </ul>
          </div>
        </div>

        <div className="services__box three" onClick={openLightbox3}>
          <h3 className="services__title">Aesthetic Treatments</h3>
          <img className="services__portrait" src={portrait3} alt="beautiful young woman with lighter skin getting a spa treatment" />
          <div className="services__list rightList">
            <ul>
              <li>Pharmaceutical-Grade Skincare</li>
              <li>Medical Facials</li>
              <li>HydraFacials</li>
              <li>Chemical Peels</li>
              <li>Latisse&#174; Eyelash Enhancement</li>
            </ul>
          </div>
        </div>
      </div>
    </>
  )
}

export default Info
